import { List, Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import ServiceProviderFileGroupingLookup from '../Models/Lookups/ServiceProviderFileGroupingLookup';
import SFTPBrokerDetailsLookup from '../Models/Lookups/SFTPBrokerDetailsLookup';
import ManageBrokerSFTPDetailsComponentVM from './ManageBrokerSFTPDetailsComponentVM';
import StaticServiceProviderModel from '../../../Common/Models/StaticServiceProviderModel';
import { DaysOfWeekEnum } from '../../../Common/Enums/DaysOfWeekEnum';
@NeoModel
export default class ManageServiceProviderFileGroupingComponentVM extends Views.ViewModelBase {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public managedServiceProviderFileGrouping = new ServiceProviderFileGroupingLookup();
    public SFTPDetailsList = new List(SFTPBrokerDetailsLookup);
    public manageBrokerSFTPDetails = new ManageBrokerSFTPDetailsComponentVM();
    public showManageServiceProviderFileGroupingInd: boolean = false;
    public serviceProviderList = new List(StaticServiceProviderModel);
    public selectedServiceProvider = new StaticServiceProviderModel();
    public isReadOnlyInd: boolean = false;
    public addNewServiceProviderInd: boolean = false;
    public selectedIItem: Model.ISelectedItem[] = [];

    public async initialise() {
        this.showManageServiceProviderFileGroupingInd = true;
        await this.setServiceProviderList();

        var response = await this.serviceProviderApiClient.getSFTPBrokerDetails(this.managedServiceProviderFileGrouping.staticServiceProviderFileGroupingId);
        this.SFTPDetailsList.set(response.data);
        this.loadDaysOfWeekForBroker();
    }

    public getDaysOfWeekEnumList(searchString?: string) {
        let map: { id: number, name: string }[] = [];
        let keys = Object.keys(DaysOfWeekEnum).filter((v) => isNaN(Number(v)));
        keys.forEach((key, index) => {
            if (searchString === undefined || (searchString !== undefined && key.toString().includes(searchString!))) {
                map.push({ id: index, name: key.toString() });
            }
        })
        return map;
    }

    public async loadDaysOfWeekForBroker() {
        if (this.managedServiceProviderFileGrouping.staticServiceProviderFileGroupingId) {
            const currentBroker = await this.taskRunner.waitFor(this.serviceProviderApiClient.getServiceProviderFileGroupingLookupById(this.managedServiceProviderFileGrouping.staticServiceProviderFileGroupingId));
            const brokerExportDaysOfWeek = currentBroker.data.daysOfWeek;
            if (brokerExportDaysOfWeek == null || brokerExportDaysOfWeek.length === 0) {
                this.managedServiceProviderFileGrouping.selectedDaysOfWeek = this.selectedIItem;
            }
            else {
                this.managedServiceProviderFileGrouping.selectedDaysOfWeek = currentBroker.data.selectedDaysOfWeek;
            }
        }
    }

    public async addNewSFTPDetails(staticServiceProviderFileGroupingId: number = 0) {
        let sftpBrokerDetails = this.SFTPDetailsList.addNew();
        this.manageBrokerSFTPDetails.initialise();

        sftpBrokerDetails.staticServiceProviderSftpdetailsId = -1;
        sftpBrokerDetails.staticServiceProviderFileGroupingId = staticServiceProviderFileGroupingId;

        this.manageBrokerSFTPDetails.managedBrokerSFTPDetails = sftpBrokerDetails;
    }

    public async editSFTPDetails(SFTPBrokerDetails: SFTPBrokerDetailsLookup) {
        this.manageBrokerSFTPDetails.initialise();
        this.manageBrokerSFTPDetails.managedBrokerSFTPDetails = SFTPBrokerDetails;
    }

    public async cancelEditSTFPDetails() {
        this.manageBrokerSFTPDetails.managedBrokerSFTPDetails = new SFTPBrokerDetailsLookup();
        var response = await this.serviceProviderApiClient.getSFTPBrokerDetails(this.managedServiceProviderFileGrouping.staticServiceProviderFileGroupingId);
        this.SFTPDetailsList.set(response.data);
    }

    public saveDaysOfWeek() {
        if (this.managedServiceProviderFileGrouping && this.managedServiceProviderFileGrouping.isValid) {
            var selectedDaysOfWeek = this.managedServiceProviderFileGrouping.selectedDaysOfWeek;

            if(this.managedServiceProviderFileGrouping.daysOfWeek === null){
                this.managedServiceProviderFileGrouping.daysOfWeek = []
            }

            selectedDaysOfWeek.forEach(element => {
                if(element !== undefined)
                {
                    this.managedServiceProviderFileGrouping.daysOfWeek.push(element.display);
                }
            });
        }
    }

    public async setServiceProviderList() {
        var response = await this.serviceProviderApiClient.getServiceProviderListByCriteria(" ");
        this.serviceProviderList.set(response.data);

        if (!this.serviceProviderList.find(x => x.serviceProviderName === "NEW")) {
            var newSSPFG = new StaticServiceProviderModel();
            newSSPFG.staticServiceProviderId = 0;
            newSSPFG.serviceProviderName = "NEW";
            this.serviceProviderList.push(newSSPFG);
        }
    }

    public setSelectedServiceProvider(serviceProviderId: number) {
        this.selectedServiceProvider = this.serviceProviderList.find(x => x.staticServiceProviderId === serviceProviderId)!;

        if (serviceProviderId !== 0) {
            this.isReadOnlyInd = true;
            this.managedServiceProviderFileGrouping.meta.serviceProviderCode.value = this.selectedServiceProvider.meta.serviceProviderCode.value;
            this.managedServiceProviderFileGrouping.meta.serviceProviderName.value = this.selectedServiceProvider.meta.serviceProviderName.value;
            this.managedServiceProviderFileGrouping.meta.serverName.value = this.selectedServiceProvider.meta.serverName.value;
            this.managedServiceProviderFileGrouping.meta.serviceProviderSubAccountName.value = this.selectedServiceProvider.meta.serviceProviderSubAccountName.value;
        }
        else if (serviceProviderId === 0) {
            this.isReadOnlyInd = false;
            this.managedServiceProviderFileGrouping.meta.serviceProviderName.value = "";
            this.managedServiceProviderFileGrouping.meta.serviceProviderCode.value = "";
            this.managedServiceProviderFileGrouping.meta.serverName.value = "";
            this.managedServiceProviderFileGrouping.meta.serviceProviderSubAccountName.value = "";
        }
    }
}